/*
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 *
 */

import { Header as VaiHeader, Icon } from '@vaisala/rockhopper-components';
import { VaiIcon } from '@vaisala/rockhopper-design-tokens';
import { useModal } from '../state/modal';
import { useTranslation } from 'react-i18next';
import {  useNavigate } from 'react-router-dom';
import { useAuth } from '../state/auth/AuthContext';


interface HeaderProps {
  title: string;
  logoVisible: boolean;
}

export const Header = ({ title, logoVisible }: HeaderProps) => {
  const { t } = useTranslation();
  const { modals } = useModal();
  const { logout } = useAuth();


  return (
    <VaiHeader logoVisible={logoVisible} title={t(title)}>
      {/* <VaiHeader.Item startIcon={<Icon name={VaiIcon.Settings} />} title={t('header.settings')} onClick={modals.settings} /> */}
      <VaiHeader.Item startIcon={<Icon name={VaiIcon.Logout} />} title={t('header.logout')} onClick={logout} />
    </VaiHeader>
  );
};
